import moment from 'moment';

export const validateLicense = (value) => {
  return (
    moment(value.start_date * 1000).isSameOrBefore(moment()) &&
    moment(value.end_date * 1000).isSameOrAfter(moment())
  );
};
